<template>
  <CustomSimpleButton
    :aria-label="ariaLabel"
    class="inline-flex cursor-pointer items-center justify-center p-1 color-primary"
    @click="onClick"
  >
    <i :class="[iconClass, iconSize]" aria-hidden="true"></i>
  </CustomSimpleButton>
</template>
<script lang="ts">
import CustomSimpleButton from "@/components/primitives/CustomSimpleButton.vue";
import { gotoDashboard, gotoPrevious } from "@/methods/utils";
import { CloseTargetType, ComponentSizeType } from "@/types/componentType";
import { alertController } from "@ionic/vue";
import { PropType, defineComponent } from "vue";

export default defineComponent({
  components: { CustomSimpleButton },
  name: "CloseButton",
  props: {
    // `null` → don't navigate; emit `onClose` so the caller handles the click itself.
    closeTarget: { type: String as PropType<CloseTargetType>, default: "home" },
    size: { type: String as PropType<ComponentSizeType>, default: "default" },
    confirmBeforeLeave: { type: Boolean, default: false },
    confirmMessage: { type: String, default: "Any unsaved changes will be lost." },
  },
  emits: ["onClose"],
  setup(props, { emit }) {
    const iconSizeMap: Record<ComponentSizeType, string> = {
      small: "text-(length:--icon-size-small)",
      default: "text-(length:--icon-size-default)",
      large: "text-(length:--icon-size-large)",
    };
    const iconSize = iconSizeMap[props.size];
    const iconClass = props.closeTarget === "home" ? "ti ti-home" : "ti ti-arrow-left";
    const ariaLabel = props.closeTarget === "home" ? "Go to dashboard" : "Go back";

    async function onClick() {
      const navigate = () => {
        if (props.closeTarget === null) {
          emit("onClose");
        } else if (props.closeTarget === "home") {
          gotoDashboard();
        } else {
          gotoPrevious();
        }
      };
      if (!props.confirmBeforeLeave) {
        navigate();
        return;
      }
      const alert = await alertController.create({
        header: "Leave this page?",
        message: props.confirmMessage,
        buttons: [
          { text: "Stay", role: "cancel" },
          { text: "Leave", role: "confirm", handler: () => navigate() },
        ],
      });
      await alert.present();
    }

    return { iconSize, iconClass, ariaLabel, onClick };
  },
});
</script>
